export default __webpack_public_path__ + "static/media/SJA1500.34I-42080_-25226_0.24f70876.jpg";